import React, { Component } from 'react';

class InputWithFocus extends Component {
  componentDidMount() {
    if (!this.props.disableFocus) {
      this._inputTimer = setTimeout(() => {
        this._input.select();
      }, 500);
    }
  }

  componentWillUnmount() {
    clearTimeout(this._inputTimer);
  }

  render() {
    const { placeholder, content, onChange, disabled, dataTestId } = this.props;
    return (
      <input
        data-testid={dataTestId}
        ref={(input) => (this._input = input)}
        type="text"
        className="form-control"
        placeholder={placeholder}
        value={content}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
      />
    );
  }
}

export default InputWithFocus;
